module.exports = __webpack_public_path__ + "img/60.9e4eed4d.jpg";